@if (loading) {
  <div class="dialog-loader">
    <sem-loader [showLoader]="true"></sem-loader>
  </div>
}


<div class="linked-data-dialog wg-m2o">

  <!-- header: eyebrow (what the dialog does), title (which registry), close -->
  <div class="wg-m2o__header">
    <div class="wg-m2o__header-left">
      <span class="wg-m2o__eyebrow">{{linkWithExistingData}}</span>
      <h1 class="dialog-title-heading wg-m2o__title">{{translationService.translate(title)}}</h1>
    </div>
    <button type="button" class="wg-m2o__close" (click)="dialogRef.close()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- filters: a card with "po vseh" (two columns), one field per configured search field and the
       search button in the same grid, aligned with the inputs -->
  <div class="wg-m2o__panel">
    <div class="m2o-search-fields-container wg-m2o__filters">
      <div class="search-mto-item search-by-all wg-m2o__field wg-m2o__field--all">
        <label class="searchfield-povseh wg-m2o__label">{{translationService.translate('galis_js_m2o_search_po_vseh')}}</label>

        @if (tooltipTextPoVseh != null) {
          <span class="control-help-m2o"></span>
        }
        @if (tooltipTextPoVseh != null) {
          <span class="tooltip-text tooltip-text-povseh">{{tooltipTextPoVseh}}</span>
        }

        <input type="text" (keydown.enter)="onKeydown($event)" class="dialog-field m2o-po-vseh-input" name="po-vseh"
          [(ngModel)]="vsaPoljaSearchValue" />
        </div>

        @for (dataItem of searchFields; track dataItem) {
          <div class="search-mto-item wg-m2o__field">
            <label class="searchfield-label wg-m2o__label">{{translationService.translate(dataItem.Title)}}</label>
            @if (showDataItemTooltiptext(dataItem)) {
              <span class="control-help-m2o"></span>
            }
            <span class="tooltip-text tooltip-text-searchfield">{{dataItem.TooltipText}}</span>
            <div class="switcher">
              @switch (dataItem.Type) {
                @case ('Text') {
                  <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" class="dialog-field"
                    (keydown.enter)="onKeydown($event)" [ngModel]="getProp(dataItem.PropertyName)"
                    (ngModelChange)="setProp(dataItem.PropertyName, $event)" name="{{dataItem.PropertyName}}">
                  </sem-text-box>
                }
                @case ('Date') {
                  <sem-date-picker class="dialog-field" (keydown.enter)="onKeydown($event)"
                    [ngModel]="getProp(dataItem.PropertyName)" (ngModelChange)="setProp(dataItem.PropertyName + 'From', $event)"
                    name="{{dataItem.PropertyName}}" date-format="DD/MM/YYYY"
                    [templateType]="'calendar_month'">
                  </sem-date-picker>
                }
              @case ('CB') {
                <sem-check-box class="dialog-field" (keydown.enter)="onKeydown($event)"
                  [ngModel]="getProp(dataItem.PropertyName)" (ngModelChange)="setProp(dataItem.PropertyName, $event)"
                  name="{{dataItem.PropertyName}}">
                </sem-check-box>
              }
            }
          </div>
        </div>
      }

      <div class="dialog-input-holder wg-m2o__actions">
        <button type="button" class="search-link wg-m2o__search-btn" (click)="search(null)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <span>{{translationService.translate('galis_js_m2o_search')}}</span>
        </button>
      </div>

    </div>
  </div>


  <!-- results: the count on the right of a thin bar, the error in its place -->
  @if (!loading || errorMessage) {
    <div class="wg-m2o__table-bar">
      @if (errorMessage) {
        <h2 class="results-found m2o-error-message wg-m2o__error">{{errorMessage}}</h2>
      } @else {
        <h2 class="results-found wg-m2o__results">{{resultsFound}}</h2>
      }
    </div>
  }

  <div class="m2o-table-wrapper wg-m2o__table-wrap">
    @if (models.length > 0 && dialogData.type != 3) {
      <table class="wg-m2o__table">
        <thead>
          <tr>
            @if (enableMultiSelect) {
              <th class="checkbox-col"></th>
            }
            @for (item of displayFields; track item) {
              <th>{{translationService.translate(item.Title)}}</th>
            }
            @if (!enableMultiSelect) {
              <th class="wg-m2o__action-col"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of modelsToDisplay; track item) {
            <!-- the row is the target: click or Enter links (single) / toggles (multi); the button at the
                 row end only appears on hover or focus as a visible hint of that -->
            <tr class="wg-m2o__row" tabindex="0"
                [class.multi-select-row]="enableMultiSelect"
                [class.wg-m2o__row--link]="!enableMultiSelect"
                [class.wg-m2o__row--selected]="enableMultiSelect && isSelected(item)"
                (click)="enableMultiSelect ? toggleSelection(item) : linkClicked(item)"
                (keydown.enter)="enableMultiSelect ? toggleSelection(item) : linkClicked(item)">
              @if (enableMultiSelect) {
                <td class="checkbox-col">
                  <input type="checkbox" [checked]="isSelected(item)" (click)="$event.stopPropagation()" (change)="toggleSelection(item)" />
                </td>
              }
              @for (displayField of displayFields; track displayField) {
                <td>
                  @if (displayField.Type == 'Image') {
                    <sem-image-viewer class="mto-image"
                    [mediaId]="resolvePropertyBinding(item, displayField.PropertyName)"></sem-image-viewer>
                  }
                  @if (displayField.Type != 'Image' && displayField.Type != 'Date') {
                    <div>
                      {{
                      resolvePropertyBinding(item,
                      displayField.PropertyName)
                      }}
                    </div>
                  }
                  @if (displayField.Type == 'Date') {
                    <div>
                      {{
                      resolvePropertyBinding(item, displayField.PropertyName) |
                      date:'dd.MM.yyyy':'CET'
                      }}
                    </div>
                  }
                </td>
              }
              @if (!enableMultiSelect) {
                <td class="wg-m2o__action-col">
                  <button type="button" class="linkicon wg-m2o__link-btn" tabindex="-1" (click)="$event.stopPropagation(); linkClicked(item)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                    </svg>
                    <span>{{ link || translationService.translate('galis_js_m2o_link') }}</span>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }

    @if (enableMultiSelect && !loading) {
      <div class="multi-select-footer wg-m2o__multi-footer">
        <span class="wg-m2o__multi-count">{{selectedItems.length}}</span>
        <button type="button" class="wg-m2o__primary-btn" (click)="saveSelection()" [disabled]="selectedItems.length === 0">
          {{translationService.translate('Save')}}
        </button>
      </div>
    }
  </div>


  @if (dialogData.type == 3) {
    <div class="grid-o2m">
      <ng-scrollbar [visibility]="'hover'">
        <div class="grid-view">
          <div class="border-hide"></div>
          @for (item of modelsToDisplay; track item) {
            @for (img of item.Medias; track img) {
              <div class="grid-item">
                <sem-image-viewer #imgElement [name]="img.Name" [mediaId]="img.Id" [height]="350" [width]="350" (click)="imageClick(imgElement)"></sem-image-viewer>
                <p class="grid-title">
                  {{item.Title}}
                </p>
              </div>
            }
          }
        </div>
      </ng-scrollbar>
    </div>
  }


  @if (pages.length > 0 && !loading) {
    <div class="dialog-footer table-footer wg-m2o__paging">
      @if (previousPage > 0) {
        <button type="button" class="wg-m2o__page-nav" (click)="toFirstPage()" aria-label="First page">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
        </button>
        <button type="button" class="wg-m2o__page-nav" (click)="pageChanged(previousPage)" aria-label="Previous page">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
      }
      @for (page of pages; track page) {
        <button type="button" class="wg-m2o__page" [class.active]="page.Active == true" (click)="pageChanged(page.Number)">
          {{page.Number}}
        </button>
      }
      @if (nextPage > 0) {
        <button type="button" class="wg-m2o__page-nav" (click)="pageChanged(nextPage)" aria-label="Next page">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <button type="button" class="wg-m2o__page-nav" (click)="toLastPage()" aria-label="Last page">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
        </button>
      }
    </div>
  }


</div>
